<template>
  <div>
    <imgHeader imgUrl="/img/4文章详情页-banner.jpg" />
    <div class="container w">
      <h3>欢迎义乌市领导出席凯美特日用百货中心开工奠基仪式</h3>
      <div class="detail">
        <p class="time">发布时间：2010-01-10</p>
        <p class="humanity">发布人：美事达</p>
      </div>
      <div class="news-details">
        <p>
          昨天(11月15日)上午，由西班牙马德里欧洲国贸城投资的义乌凯美特日用百货物流中心项目开工。义乌市领导盛秋平、季金甫、颜新香、何文飞参加开工奠基仪式。
        </p>
        <img src="/img/4文章详情页-img1.jpg" alt="" />
        <p>
          欧洲国贸城一义乌凯美特日用百货物流中心项目建设用地56.5亩，将拟建高架仓库、物流分拣中心、物流配送中心、办公楼、宿舍楼等相关附属配套工程，项目
          建成后，将运用“拉式补货”的原理，利用统一的智能化管理软件，为全球各地的客户进行智能化补货，配货。同时，货物也会通过仓储，二次包装等加工后再依托“义新欧“
          欧班列运输到国外，并转运到客户的公司。仓储物流中心将致力于打造一个智能化的全球仓储、配货服务中心，为各地客户提供一站采购、运输、清关、转运等全方面服务。
        </p>
        <img src="/img/4文章详情页-img2.jpg" alt="" />
        <p>
          义乌市凯美特日用百货有限公司董事长夏永平表示，项目的开工奠基是一个全新的发展起点。未来，公司将在全球20个国家地区直接成立分部，形成宽广、系统销售体系，把中国制造的优势更快速、更有效、更实惠地推向世界。
        </p>
        <img src="/img/4文章详情页-img3.jpg" alt="" />
        <p>
          “欧洲国贸城集团是义新欧在西班牙的第一个大客户，从“义新欧”中欧班列运行以来便一直保持着紧密合作。从整柜的输出到其他的产品开发，欧洲国贸城集团一直参与在义新欧的成长中。”浙江天盟实业有限公司董惠长好冯旭斌表示，随着班列运行的不段加密，欧洲国贸城集团在义乌
          设立仓储中心的创新举措的，将会带来新的发展机遇。依托“一带一路”发展机遇和“义新欧”中欧班列的综合优势，将会带动更多在欧洲以商贸为主的公司参考、学习该运营模式，设立类似欧洲国贸城一义乌凯美特日用百货物流中心的项目。
        </p>
        <img src="/img/4文章详情页-img4.jpg" alt="" />
        <p>
          “今天的开工奠基是‘义新欧’中欧班列开通以来最大的贸易成果。”冯旭斌激动地说，作为班列运营主体，下一步天盟实业会根据仓储中心的建设和投入使用情况，为期提供对性的订单式物流方案。
        </p>
        <img src="/img/4文章详情页-img5.jpg" alt="" />
        <p>
          近年来，义乌主动融入国家对外开放大格局，积极参与“一带一路”建设，探索跨国海关和铁路协调机制，谋划“义新欧”经贸合作项目，提升“义甬舟”开放大通道对腹地的辐射能力，
          聚力打造亚欧大陆互联互通重要桥梁，更好地促进中欧市场深度融通。期间，先后引进了德国动力总成、英伦新能源整车、沃尔沃发动机等重大产业项目，集LED配套产业链的光源
          科技小镇成功实现了木林森并购德国欧司朗照明等企业跨国并购，为义乌打造百年基业奠定坚实基础。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'News',
  }
</script>

<style lang="scss" scoped>
  .container {
    h3 {
      text-align: center;
    }
    .detail {
      display: flex;
      justify-content: space-between;
      width: 370px;
      margin: 0 auto 60px;
      p {
        margin-top: 0;
        color: #333;
      }
    }
  }
  .news-details {
    margin-bottom: 90px;
    text-align: center;
    img {
      margin: 36px auto;
    }
    p {
      margin: 0;
      line-height: 1.8;
      text-indent: 2em;
      text-align: justify;
    }
  }
</style>
